export default function loadScript(src, { async = true, id } = {}) {
  return new Promise((resolve, reject) => {
    if (id && document.getElementById(id)) {
      // already loaded
      resolve();
      return;
    }

    const scriptElement = document.createElement('script');

    if (id) {
      scriptElement.id = id;
    }

    scriptElement.setAttribute('src', src);
    scriptElement.setAttribute('type', 'text/javascript');
    scriptElement.setAttribute('async', async);

    document.body.appendChild(scriptElement);

    scriptElement.addEventListener('load', () => {
      resolve();
    });

    scriptElement.addEventListener('error', error => {
      reject(error);
    });
  });
}
